import { merge } from 'lodash';
import randomString from "@/utils/generateRandomString";

const initialState = {
  nome: '',
  origemBase: 'ARQUIVO',
  origemBaseList: [
    { text: "Arquivo CSV", value: "ARQUIVO" },
    { text: "AIS", value: "AIS" },
    { text: "Laudo Blindado", value: "LAUDO_BLINDADO" }
  ],
  dataBase: null,
  arquivoAis: {
    id: null,
    delimitador: null,
    involucro: null,
    escape: null,
    mapeamento: {
      "IMOBILIZADO": "",
      "SUBNUMERO": "",
      "IDUC": "",
      "DATA_IMOBILIZACAO": "",
      "ODI": "",
      "TI": "",
      "TUC": "",
      "A1": "",
      "A2": "",
      "A3": "",
      "A4": "",
      "A5": "",
      "A6": "",
      "UAR": "",
      "UAR_PRINCIPAL": "",
      "QTD": "",
      "VOC": "",
      "DEP_VOC": "",
    },
    camposObrigatorios: ["IMOBILIZADO", "SUBNUMERO", "DATA_IMOBILIZACAO", "ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6", "UAR", "UAR_PRINCIPAL", "QTD", "VOC", "DEP_VOC"]
  },
  arquivoBaixas: {
    id: "",
    fileObj: undefined,
    delimitador: `;`,
    involucro: `"`,
    escape: `"`,
    uploading: false,
    fakeFile: false,
    headerValido: false
  },
  somenteUarPrincipal: true,
  atributosCoringa: false,
  atributosRodadas: ["IMOBILIZADO", "SUBNUMERO", "IDUC", "ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6", "UAR"],
  rodadas: [
    { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6", "UAR"] },
    { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6"] },
    { key: randomString(30), valores: ["TUC", "A1", "A2", "A3", "A4", "A5", "A6"] },
    { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1"] },
    { key: randomString(30), valores: ["ODI", "TI", "TUC"] },
    { key: randomString(30), valores: ["TUC"] }
  ]
};
  
const state = initialState;
  
const getters = {};
  
const actions = {
  setSimulacaoBaixas({ commit }, value) {
    commit('SET_SIMULACAO_BAIXAS', value)
  },
  setSimulacaoBaixasRodadas({ commit }, value) {
    commit('SET_SIMULACAO_BAIXAS_RODADAS', value)
  },
  clearSimulacaoBaixas({ commit }, value) {
    commit('CLEAR_SIMULACAO_BAIXAS', initialState)
  }
};
  
const mutations = {
  SET_SIMULACAO_BAIXAS: (state, value) => (state = merge(state, value)),
  SET_SIMULACAO_BAIXAS_RODADAS: (state, value) => (state.rodadas = value),
  CLEAR_SIMULACAO_BAIXAS: (state, value) => {
    state = merge(state, value);
    state.arquivoBaixas.fileObj = undefined;
  }
};
  
export default {
  state,
  getters,
  actions,
  mutations
};